import { Check, ArrowRight } from "lucide-react";
import { SectionHeading } from "../components/SectionHeading";
import { Reveal } from "../components/Reveal";
import { scrollToHash } from "../components/Navbar";

const BENEFITS = [
    {
        title: "Flexible Product Selection",
        description: "A broad range of everyday product categories.",
    },
    {
        title: "Business-Focused Service",
        description: "A straightforward approach to wholesale enquiries and supply requirements.",
    },
    {
        title: "Reliable Communication",
        description: "Clear communication throughout the enquiry process.",
    },
];

export const Wholesale = ({ onWholesaleEnquiry }) => (
    <section id="wholesale" data-testid="wholesale-section" className="bg-white">
        <div className="mx-auto grid max-w-7xl items-center gap-12 px-5 py-20 sm:px-8 lg:grid-cols-2 lg:gap-16 lg:py-28">
            <div>
                <SectionHeading eyebrow="For Businesses" title="Wholesale Supply for Businesses" />
                <Reveal delay={120}>
                    <p className="mt-6 text-base leading-relaxed text-slate-600 sm:text-lg">
                        PISI LIMITED provides wholesale product supply for businesses looking to
                        source everyday consumer goods, groceries, beverages, household products and
                        general retail products.
                    </p>
                    <ul className="mt-9 space-y-6">
                        {BENEFITS.map((benefit) => (
                            <li key={benefit.title} className="flex gap-4">
                                <span className="mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center bg-navy-900 text-gold">
                                    <Check className="h-4 w-4" />
                                </span>
                                <div>
                                    <h3 className="font-heading text-base font-semibold text-navy-900">
                                        {benefit.title}
                                    </h3>
                                    <p className="mt-1 text-sm leading-relaxed text-slate-600">
                                        {benefit.description}
                                    </p>
                                </div>
                            </li>
                        ))}
                    </ul>
                    <button
                        type="button"
                        data-testid="wholesale-cta-button"
                        onClick={() => {
                            onWholesaleEnquiry();
                            scrollToHash("#contact");
                        }}
                        className="group mt-10 inline-flex items-center gap-2 bg-navy-900 px-7 py-3.5 text-sm font-semibold text-white transition-colors duration-200 hover:bg-navy-800"
                    >
                        Make a Wholesale Enquiry
                        <ArrowRight className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-0.5" />
                    </button>
                </Reveal>
            </div>

            <Reveal delay={150} className="relative">
                <div
                    className="absolute -left-4 -top-4 hidden h-full w-full border border-gold/50 sm:block"
                    aria-hidden="true"
                />
                <img
                    src="/images/wholesale-warehouse.jpg"
                    alt="Business owner serving a customer at a retail counter"
                    data-testid="wholesale-image"
                    className="hero-image-frame relative h-[300px] w-full object-cover sm:h-[420px] lg:h-[500px]"
                    loading="lazy"
                />
            </Reveal>
        </div>
    </section>
);
